import { IconProps } from './index';

const ArrowFull: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="7"
            height="4"
            viewBox="0 0 7 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M3.49935 3.66671L0.166016 0.333374H6.83268L3.49935 3.66671Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default ArrowFull;
